import { DeclaredUnit, IComponentDetails } from '../../interfaces/IComponentDetails';
import { RetroOrProspectivePcfType } from '../../interfaces/IFootprint';
import { IProduct } from '../../interfaces/IProduct';

export type ActivePcfViewModel = {
  id?: string | number;
  createdDate?: string;
  declaredUnit?: DeclaredUnit;
  unitaryProductAmount?: number;
  validityPeriodEnd?: string;
  retroOrProspectivePcfType?: RetroOrProspectivePcfType;
  pcfExcludingBiogenic?: number;
  pcfIncludingBiogenic?: number;
  pcfLegalStatement?: string;
};

export const mapProductToActivePcf = (product?: IProduct): ActivePcfViewModel => {
  return {
    id: product?.pcf?.activeCarbonFootprintId,
    createdDate: product?.pcf?.activeCarbonFootprintCreatedDate,
    declaredUnit: product?.pcf?.activeCarbonFootprintDeclaredUnit,
    unitaryProductAmount: product?.pcf?.activeCarbonFootprintUnitaryProductAmount,
    validityPeriodEnd: product?.pcf?.activeCarbonFootprintValidityPeriodEnd,
    retroOrProspectivePcfType: product?.pcf?.activeCarbonFootprintRetroOrProspectivePcfType,
    pcfExcludingBiogenic: product?.pcf?.pcfExcludingBiogenic,
    pcfIncludingBiogenic: product?.pcf?.pcfIncludingBiogenic,
    pcfLegalStatement: product?.pcf?.activeCarbonFootprintPcfLegalStatement,
  };
};

export const mapComponentToActivePcf = (component?: IComponentDetails): ActivePcfViewModel => {
  return {
    id: component?.pcf?.id,
    createdDate: component?.created,
    declaredUnit: component?.pcf?.declaredUnit,
    unitaryProductAmount: component?.pcf?.unitaryProductAmount,
    validityPeriodEnd: component?.pcf?.validityPeriodEnd,
    retroOrProspectivePcfType: component?.pcf?.retroOrProspectivePcfType,
    pcfExcludingBiogenic: component?.pcf?.pcfExcludingBiogenic,
    pcfIncludingBiogenic: component?.pcf?.pcfIncludingBiogenic,
    pcfLegalStatement: component?.pcfLegalStatement,
  };
};
